import { demandConstants } from "./types";

const initialState = {
  addedFeedback: false,
  addedAgent: false,
  submitDemandOptions: [],
  isLoadingDemandOptions: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case demandConstants.ADD_FEEDBACK_REQUEST:
      return {
        ...state,
        addedFeedback: false,
        feedbackErrorMessage: null,
      };
    case demandConstants.ADD_FEEDBACK_SUCCESS:
      return {
        ...state,
        addedFeedback: true
      };
    case demandConstants.GET_MY_DEMANDS_REQUEST:
      return {
        ...state,
        ...action.payload
      };
    case demandConstants.GET_MY_DEMANDS_SUCCESS:
      return {
        ...state,
        ...action.payload
      };
    case demandConstants.ASK_TO_AGENT_REQUEST:
      return {
        ...state,
        addedAgent: false
      };
    case demandConstants.ASK_TO_AGENT_SUCCESS:
      return {
        ...state,
        addedAgent: true
      };
    case demandConstants.CLEAR_SUCCESS_MESSAGE:
      return {
        ...state,
        addedFeedback: false,
        addedAgent: false,
        isLoading: true
      };
    case demandConstants.DEMANDS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error,
        feedbackErrorMessage: action.message || null,
      };
    default:
      return state;

    case demandConstants.GET_SUBMIT_DEMAND_OPTIONS_REQUEST:
      return {
        ...state,
        submitDemandOptions: [],
        isLoadingDemandOptions: true,
      };
    case demandConstants.GET_SUBMIT_DEMAND_OPTIONS_SUCCESS:
      return {
        ...state,
        submitDemandOptions: action.payload.submitDemandOptions,
        isLoadingDemandOptions: false,
      };
    case demandConstants.GET_MEMBER_FEK_REQUEST:
      return {
        ...state,
        memberFek: null,
        isLoading: true

      };
    case demandConstants.GET_MEMBER_FEK_SUCCESS:
      return {
        ...state,
        memberFek: action.payload.memberFek,
        isLoading: false
      };
    case demandConstants.CLEAR_MEMBER_FEK:
      return {
        ...state,
        memberFek: [],
        isLoading: false,
      };

    case demandConstants.GET_MEMBER_IBAN_REQUEST:
      return {
        ...state,
        memberIban: null,
        isLoading: true

      };
    case demandConstants.GET_MEMBER_IBAN_SUCCESS:
      return {
        ...state,
        memberIban: action.payload.memberIban,
        isLoading: false
      };
    case demandConstants.CLEAR_MEMBER_IBAN:
      return {
        ...state,
        memberIban: [],
        isLoading: false,
      };
  }
};
